import { ItemInstance } from '@headless-tree/core';
import React, { useMemo } from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { GoalHeader as TaskCardGoalHeader } from 'shared/components/ui/task-card-task-section/goal-header';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { DataType } from 'shared/types/data-type';
import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';
import { goalInboxID } from 'shared/types/orderable-section';

import * as Styled from './goal-header.style';

export type GoalHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
  goals: Goal[];
  lifeAreas: LifeArea[];
  denseFormat?: boolean;
};

export const GoalHeader: React.FC<GoalHeaderProps> = ({
  item,
  goals,
  lifeAreas,
  denseFormat,
}) => {
  const onPremium = useOpenPremiumDialog();
  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  const goalId = item.getItemData().sourceId;
  const goal = useMemo(
    () => goals.find((g) => g.id === goalId),
    [goalId, goals],
  );

  return (
    <Styled.HeaderContainer
      $denseFormat={denseFormat}
      data-component-type={DataType.Goal}
      data-id={goalId}
      data-title={goal?.name}
    >
      <TaskCardGoalHeader
        goalId={goalId !== goalInboxID ? goalId : undefined}
        goals={goals}
        lifeAreas={lifeAreas}
        onPremium={onPremium}
        isLink
      />
      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.HeaderContainer>
  );
};
